import IngestWidget from './ingest-widget';
export default IngestWidget;
